export { default as PersistantPricing } from './persistantPricing'



// WEBPACK FOOTER //
// ./src/components/header/promos/shop/persistantPricing/index.js